function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 1.6.0-rc.1");

var _ref3 = /*#__PURE__*/React.createElement("defs", null);

function SvgDnLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 209.9738281250001,
    height: 50,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("g", {
    transform: "translate(130 30) scale(0.91 0.91)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial",
    fontSize: 40,
    fontWeight: "normal",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#ffffff",
      fillRule: "nonzero",
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -28.89,
    y: 8.98,
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#ffffff",
      fillRule: "",
      opacity: 1
    }
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 8.98,
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#ffffff",
      fillRule: "",
      opacity: 1
    }
  }, "N"))), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(0 6) scale(.9 .93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21.78 39.231 c 0.196 0.106 17.232 -19.775 36.559 -38.316 c 0.481 -0.297 0.418 -0.525 1.61 -0.912 c 1.229 -0.042 1.572 0.446 1.992 0.629 c 0.772 0.512 1.452 1.031 2.104 1.569 c 1.316 1.067 2.563 2.162 3.784 3.262 c 2.442 2.2 4.788 4.417 7.042 6.577 c 4.507 4.319 8.652 8.426 12.21 11.971 c 7.106 7.094 11.843 11.962 12.028 12.155 c 0.727 0.776 0.519 2.149 -0.465 3.065 c -0.985 0.914 -2.364 1.029 -3.085 0.257 c -0.184 -0.19 -4.686 -5.253 -11.441 -12.64 c -3.38 -3.69 -7.321 -7.964 -11.599 -12.462 c -2.141 -2.245 -4.365 -4.549 -6.667 -6.821 c -1.15 -1.139 -2.324 -2.268 -3.521 -3.335 c -0.595 -0.538 -1.21 -1.047 -1.799 -1.478 c -0.298 -0.429 -0.586 0.151 -0.301 -0.75 c 0.534 0.794 -0.272 0.455 -0.423 0.849 C 40.133 20.086 21.872 39.428 21.78 39.231",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#2aafa9",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 77.763 39.231 c -0.196 0.106 -17.233 -19.775 -36.557 -38.316 c -0.483 -0.297 -0.42 -0.525 -1.611 -0.912 c -1.229 -0.042 -1.573 0.446 -1.993 0.629 c -0.772 0.512 -1.451 1.031 -2.104 1.569 c -1.316 1.067 -2.563 2.162 -3.784 3.262 c -2.443 2.2 -4.788 4.417 -7.044 6.577 c -4.506 4.319 -8.651 8.426 -12.208 11.971 C 5.355 31.104 0.619 35.972 0.434 36.166 c -0.728 0.776 -0.519 2.149 0.465 3.065 c 0.985 0.914 2.363 1.029 3.085 0.257 c 0.184 -0.19 4.685 -5.253 11.441 -12.64 c 3.38 -3.69 7.321 -7.964 11.599 -12.462 c 2.141 -2.245 4.365 -4.549 6.667 -6.821 c 1.15 -1.139 2.324 -2.268 3.521 -3.335 c 0.595 -0.538 1.21 -1.047 1.799 -1.478 c 0.297 -0.429 0.586 0.151 0.301 -0.75 c -0.534 0.794 0.272 0.455 0.422 0.849 C 59.411 20.086 77.672 39.428 77.763 39.231",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#c2e8e6",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDnLogo);
export default __webpack_public_path__ + "static/media/dn-logo.c3cc1b69.svg";
export { ForwardRef as ReactComponent };